var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};

_global.SENTRY_RELEASE = {
  id: "5f3ec1c1988523f8ce25ca8cc0be91b2214a6b7c"
};